export const dynamicId = () => {
  const id = (Math.random(12) + 25)?.toString()
  return id
}
